<h3>Comments & Questions</h3>
<hr>

<app-text-area [label]="commentsQuestionLabel" 
    [control]="feedbackForm.controls.comments">
</app-text-area>

@if(showAppointAgent && model.feedback?.appointAgentTextQuestion && !isVevo) {
    <app-radio-input [label]="model.feedback!.appointAgentTextQuestion!"
        shortLabel="Appoint Agent"
        [control]="feedbackForm.controls.appointAgent"
        [options]="[{value: 'no', label: 'Not Likely'}, {value: 'maybe', label: 'Likely'}, {value: 'yes', label: 'Very Likely'}]">
    </app-radio-input>
}
@if(!isVevo){

    <app-select-input [label]="'When do you plan to start the process?'" shortLabel="Start Process" placeholder="Select an Option"
        [control]="feedbackForm.controls.startProcess"
        [options]="startProcessOptions"
        [useStringValue]="true">
     </app-select-input>

    
}
@if(isVevo){
    <app-radio-input [label]="'Are you currently a client of ' + firmName + '?'"
        shortLabel="Current Client"
        [control]="feedbackForm.controls.currentClient"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
}
@if(feedbackForm.controls.currentClient.value === 'true' && isVevo){
    <app-text-input [label]="'Provide your Client Reference Number'" shortLabel="Client Reference Number"
        [control]="feedbackForm.controls.clientReferenceNumber">
    </app-text-input>
}